// extracted by mini-css-extract-plugin
export default {"box":"FileList_box__drd4I","grid":"FileList_grid__4U6C2","fileItem":"FileList_fileItem__dFgVe","fileOffset":"FileList_fileOffset__brNlf","fileName":"FileList_fileName__oS+XZ"};